import styled, { keyframes, css } from 'styled-components'
import { colors } from '../../../style'

export const DownloadPage = styled.main`
    font-family: 'Poppins', system-ui, -apple-system, sans-serif;
    background: ${colors.lightGrey};
    color: ${colors.black};
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 22px;
    -webkit-font-smoothing: antialiased;
`

export const Wrap = styled.div`
    width: 100%;
    max-width: 560px;
    text-align: center;
`

export const Eyebrow = styled.p`
    color: ${colors.green};
    font-weight: 700;
    font-size: 15px;
    letter-spacing: 1.5px;
    margin-bottom: 10px;
`

export const Title = styled.h1`
    font-weight: 800;
    font-size: 64px;
    letter-spacing: -1px;
    line-height: 1;
    margin-bottom: 22px;

    @media screen and (max-width: 480px) {
        font-size: 52px;
    }
`

export const Desc = styled.p`
    color: #33383c;
    font-size: 17px;
    line-height: 1.6;
    font-weight: 400;
    max-width: 480px;
    margin: 0 auto 30px;
`

export const Status = styled.div`
    min-height: 34px;
    margin-bottom: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 11px;
    color: #5b6064;
    font-size: 14.5px;
    font-weight: 500;
`

const spin = keyframes`
    to { transform: rotate(360deg); }
`

export const Spinner = styled.span`
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 3px solid #dcdcdc;
    border-top-color: ${colors.green};
    animation: ${spin} 0.8s linear infinite;

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`

const fill = keyframes`
    from { width: 0; }
    to { width: 100%; }
`

export const Progress = styled.div`
    width: 220px;
    max-width: 70%;
    height: 4px;
    border-radius: 999px;
    background: #dcdcdc;
    margin: 0 auto 22px;
    overflow: hidden;
`

export const ProgressFill = styled.div`
    height: 100%;
    border-radius: 999px;
    background: ${colors.green};
    animation: ${fill} ${(p) => p.$duration || 2000}ms linear forwards;

    @media (prefers-reduced-motion: reduce) {
        animation: none;
        width: 100%;
    }
`

export const Stores = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: center;
`

export const StoreButton = styled.a`
    display: inline-flex;
    align-items: center;
    gap: 12px;
    background: ${colors.black};
    color: ${colors.white};
    text-decoration: none;
    padding: 16px 28px;
    border-radius: 40px;
    font-weight: 600;
    font-size: 16.5px;
    transition: transform 0.12s ease, box-shadow 0.12s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 12px 26px rgba(0, 0, 0, 0.22);
    }

    &:focus-visible {
        outline: 3px solid ${colors.green};
        outline-offset: 3px;
    }

    svg {
        flex: 0 0 auto;
    }

    @media screen and (max-width: 480px) {
        width: 100%;
        justify-content: center;
    }

    @media (prefers-reduced-motion: reduce) {
        transition: none;
    }
`

export const Foot = styled.p`
    margin-top: 34px;
    color: #8b9094;
    font-size: 14px;
    font-weight: 500;
`

export const srOnly = css`
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
`
